import * as React from "react";
import type { SVGProps } from "react";
const SvgPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    role="img"
    focusable={false}
    {...props}
  >
    <path
      fill="#1D1D1D"
      d="M16.608 9.608h-6.216V3.392a.392.392 0 0 0-.784 0v6.216H3.392a.392.392 0 0 0 0 .784h6.216v6.216a.392.392 0 0 0 .784 0v-6.216h6.216a.392.392 0 0 0 0-.784"
    />
  </svg>
);
export default SvgPlus;
